// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"29b78681","455":"205e3ee8","977":"3cf49e57"}[chunkId] + ".chunk.js";
};